import React from "react";
import './HomeControl.css';
import { navigateToLandingPage } from "utilities/js/NavigationHelper";
import { NavigatorWrapper } from "./NavigatorWrapper";
import Constants from "utilities/js/Constants";

const homeIcon = Constants.ICON_LOGO;

class homeControl extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            disableFixed: props.disableFixed != null ? true : false
        };

        this.navigateToLandingPage = this.navigateToLandingPage.bind(this);
    }

    get buttonContainerClass() {
        return 'home-button-container ' + (this.state.disableFixed ? 'inline' : 'fixed');
    }

    navigateToLandingPage(event) {
        // navigateToLandingPage()
        navigateToLandingPage({routerNav: this.props.navigate});
    }

    render() {


        return (
            <div className={this.buttonContainerClass}>
                <div className="home-button" onClick={this.navigateToLandingPage}><img className="home-icon" alt="home-icon" src={homeIcon}></img></div>
            </div>
        );
    }
}

export default NavigatorWrapper(homeControl);
